/** What a tenant editor may write back to `usage_limits_override.addons`.
 *
 *  `get_effective_tenant_limits` merges the override over the plan shallowly,
 *  so this list REPLACES the plan's rather than adding to it — whatever is
 *  written here is the tenant's complete entitlement.
 *
 *  That is what made the old code dangerous. It rebuilt the list from the
 *  add-on definitions it happened to render, so every key outside that catalog
 *  — `white_label`, `extra_users`, `extra_sub_tenant_packs`, `feature_unlocks`
 *  — was deleted by a save that never mentioned them. In production that
 *  dropped `white_label` from a live tenant, `white_label_enabled()` went
 *  false, and its custom domain stopped resolving to it.
 */

/** The add-on list to persist.
 *
 *  `managedKeys` is the set of add-ons the editor actually rendered a toggle
 *  for. Only those are decided by `enabledKeys`; everything else the tenant
 *  holds is carried through untouched, because a control that was never shown
 *  cannot be read as a decision to remove it.
 */
export const addonsToPersist = ({ existingAddons, managedKeys, enabledKeys }) => {
  const managed = new Set(managedKeys || []);
  const held = Array.isArray(existingAddons) ? existingAddons : [];
  const untouched = held.filter((key) => !managed.has(key));
  const enabled = (enabledKeys || []).filter((key) => managed.has(key));
  // Order is not significant to the backend, but a stable one keeps the stored
  // JSON readable and its diffs small.
  return Array.from(new Set([...untouched, ...enabled]));
};
